<template>
  <div class="footer">
    <span>Crafted with &#x2764; by <a href="https://github.com/DefrostedTuna">Rick Bennett</a></span>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" type="text/scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: em(64px);
  border-top: 1px solid rgba(255, 255, 255, 0.4);
}

.footer a {
  color: $color-white !important;
}
</style>